import React, { useEffect, useMemo, useRef, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from'react-helmet';
import classes from "./warrantyForm.module.css";
import { useWarrantyForm } from "./useWarrantyForm";
import ErrorView from "../../components/ErrorView/errorView";
import { Button, Checkbox, Col, DatePicker, Divider, Form, Input, Row, Select, Space, Spin, Upload } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import dayjs from "dayjs";
import MessageSection from "./messageSection";
import PoweredBy from "../../components/MainComponent/mainComponent";
import MainComponent from "../../components/MainComponent/mainComponent";

const WarrantyForm = props => {

    const { formatMessage } = useIntl();

    const contentRef = useRef();
    const [bigclientWidth, setBigClientWidth] = useState(window.innerWidth);

    const {
        loading,
        errorMessage,
        form,
        warrantyGroup,
        allSelectOptions,
        allSelectValues,
        handleChangeSelect,
        fileList,
        contextHolder,
        handleRemoveFile,
        handleBeforeUpload,
        handleFormatFile,
        handleOnChangeFile,
        handleChangeDatePicker,
        handleSubmitForm,
        handleGetRules,
        otpLoading,
        canSendOtp,
        waitOtpSeconds,
        handleStartSendOtp,
        handleChangeEmail,
        handleChangeOTP,
        validateOtpLoading,
        validateOtpResult,
        btnDisable,
        searchValue,
        setSearchValue,
        alertMessage,
        setAlertMessage,
        uploadAlertMessage,
        setUploadAlertMessage
    } = useWarrantyForm();

    const todayDate = useMemo(()=>{
        const date = new Date();
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;

        return year+'-'+month+'-'+day;
    },[])

    useEffect(()=>{
        if(warrantyGroup?.length) {
            window?.parent?.postMessage({getCurrentWidth: true}, "*");
        }
    }, [warrantyGroup])

    useEffect(()=>{
        window.addEventListener('message', (event) => {
            // 处理消息
            if (event.data?.windowWidth) {
                setBigClientWidth(parseFloat(event.data?.windowWidth));
            }
        });

        if (contentRef?.current) {
            const height = contentRef?.current.clientHeight;
            window?.parent?.postMessage({iframeHeight: (height+20)}, "*");
        }
      
        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
              if (entry.target === contentRef.current) {
                const height = contentRef?.current.clientHeight;
                window?.parent?.postMessage({iframeHeight: (height+20)}, "*");
              }
            }
        })
      
        if (contentRef?.current) {
            resizeObserver.observe(contentRef?.current)
        }
      
        return () => {
            if (contentRef?.current) {
              resizeObserver.unobserve(contentRef?.current)
            }
        }
    }, [])

    const otpNode = useMemo(()=>{
        return <Form.Item 
            name="otp"
            rules={handleGetRules(true, null, formatMessage({
                id: "form.OTPLabel", 
                defaultMessage: "Verification Code"
            }), null)}
        >
            <Input 
                placeholder={formatMessage({
                    id: "form.OTPLabel", 
                    defaultMessage: "Verification Code"
                })+' *'}
                suffix={
                    <Space>
                        {
                            validateOtpResult === true ? <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                color: 'green',
                                fontSize: '12px',
                                fontWeight: '500'
                            }}>
                                <svg t="1743643931130" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2627" width="16" height="16"><path d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z" fill="#52C41A" p-id="2628"></path></svg>
                                <FormattedMessage id={'form.OTPInputValidMessage'} defaultMessage={'Successful'} />
                            </div> : validateOtpResult === false ? <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                color: 'red',
                                fontSize: '12px',
                                fontWeight: '500'
                            }}>
                                <svg t="1743643969439" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3840" width="16" height="16"><path d="M512 981.333333C252.8 981.333333 42.666667 771.2 42.666667 512S252.8 42.666667 512 42.666667s469.333333 210.133333 469.333333 469.333333-210.133333 469.333333-469.333333 469.333333z m44.245333-469.333333l159.914667-159.914667a31.274667 31.274667 0 1 0-44.245333-44.245333L512 467.754667 352.085333 307.84a31.274667 31.274667 0 1 0-44.245333 44.245333L467.754667 512l-159.914667 159.914667a31.274667 31.274667 0 1 0 44.245333 44.245333L512 556.245333l159.914667 159.914667a31.274667 31.274667 0 1 0 44.245333-44.245333L556.245333 512z" fill="#F5222D" p-id="3841"></path></svg>
                                <FormattedMessage id={'form.OTPInputInvalidMessage'} defaultMessage={'Wrong OTP'} />
                            </div> : null
                        }
                        <Button className={classes.otpButton} onClick={handleStartSendOtp}
                            loading={otpLoading}
                            disabled={!canSendOtp || validateOtpResult === true}
                        >
                            {
                                waitOtpSeconds ? formatMessage({
                                    id: "form.OTPWaitSecondsLabel", 
                                    defaultMessage: "Send Again ({waitOtpSeconds}s)"
                                }, {
                                    waitOtpSeconds: waitOtpSeconds
                                }) : formatMessage({
                                    id: "form.OTPSendLabel", 
                                    defaultMessage: "Send OTP"
                                })
                            } 
                        </Button>
                    </Space>
                }
                onChange={handleChangeOTP}
                readOnly={validateOtpLoading}
            />
        </Form.Item>
    }, [handleGetRules, formatMessage, validateOtpResult, handleStartSendOtp, otpLoading, canSendOtp, waitOtpSeconds, handleChangeOTP, validateOtpLoading]);

    const FormContent = useMemo(()=>{
        return <Spin spinning={loading}>
            {
                errorMessage ? <div ref={contentRef} className={classes.errorRoot}>
                    {errorMessage}
                </div> : <div ref={contentRef}>
                    <Form className={`${classes.root} ${bigclientWidth <= 768 ? classes.min_root : ''}`} form={form} onFinish={handleSubmitForm}>
                        {contextHolder}
                        <Row gutter={24}>
                            {
                                warrantyGroup?.map((w_group, w_ind)=>{
                                    return <Col span={12} key={w_ind}>
                                        {
                                            w_group?.map((c_group,c_ind)=>{
                                                return <div className={classes.group} key={c_group?.groupName+c_ind}>
                                                    {
                                                        c_group?.groupField?.find(g_field=>g_field.fieldCode === 'agent')?.display === false ? null : 
                                                        <div className={classes.group_name}>
                                                            {c_group?.groupName}
                                                        </div>
                                                    }
                                                    {
                                                        c_group?.groupField?.map((formField, f_ind)=>{
                                                            return formField.display !== true ? null : <div className={classes.fieldBox} key={formField.fieldCode+f_ind}
                                                                style={(formField.fieldType === 'single_select' && !allSelectOptions[formField.fieldCode]?.length
                                                                    && ['category', 'series', 'sku'].includes(formField.fieldCode)
                                                                ) ? {
                                                                    width: 0,
                                                                    height: 0,
                                                                    opacity: 0,
                                                                    overflow: "hidden"
                                                                } : {}}
                                                            >
                                                                {
                                                                    formField.comment ? <div className={classes.fieldComment}>
                                                                        {formField.comment}
                                                                    </div> : null
                                                                }
                                                                    {
                                                                        formField.fieldCode === 'email_address' ? <Spin spinning={validateOtpLoading}>
                                                                            <Form.Item 
                                                                                name={formField.fieldCode}
                                                                                rules={handleGetRules(formField.isRequired, formField.validate, formField.fieldName, 
                                                                                    formField.fieldCode === 'serial_number' ? 'serial_validate' : null
                                                                                )}
                                                                            >
                                                                                <Input 
                                                                                    placeholder={`${formField.fieldName} ${formField.isRequired ? '*' : ''}`}
                                                                                    onChange={(e)=>{handleChangeEmail(e.target.value)}}
                                                                                />
                                                                            </Form.Item>
                                                                            {otpNode}
                                                                        </Spin> : 
                                                                        formField.fieldType === 'text' ? <Form.Item 
                                                                            name={formField.fieldCode}
                                                                            rules={handleGetRules(formField.isRequired, formField.validate, formField.fieldName, 
                                                                                formField.fieldCode === 'serial_number' ? 'serial_validate' : null
                                                                            )}
                                                                        >
                                                                            <Input 
                                                                                placeholder={`${formField.fieldName} ${formField.isRequired ? '*' : ''}`}
                                                                            />
                                                                        </Form.Item> : 
                                                                        formField.fieldType === 'single_select' ? <Form.Item 
                                                                            name={formField.fieldCode}
                                                                            rules={!formField.isRequired ? [] : [{ required: true, message: formatMessage({
                                                                                id: "form.isRequired", 
                                                                                defaultMessage: "{name} is required!"
                                                                            }, {
                                                                                name: formField.fieldName
                                                                            }) }]}
                                                                        >
                                                                            <Select 
                                                                                placeholder={`${formField.fieldName} ${formField.isRequired ? '*' : ''}`}
                                                                                value={allSelectValues[formField.fieldCode]}
                                                                                options={searchValue[formField.fieldCode]
                                                                                    ? allSelectOptions[formField.fieldCode]?.filter(all_sel =>
                                                                                        all_sel.label.toLowerCase().includes(searchValue[formField.fieldCode].toLowerCase())
                                                                                    )
                                                                                    : allSelectOptions[formField.fieldCode]
                                                                                }
                                                                                onChange={(val)=>{handleChangeSelect(formField.fieldCode, val)}}
                                                                                // showSearch
                                                                                // optionFilterProp="label"
                                                                                dropdownRender={(menu)=>(<div>
                                                                                    <div style={{ padding: 8 }}>
                                                                                        <Input
                                                                                            placeholder={formatMessage({
                                                                                                id: "form.selectInputLabel", 
                                                                                                defaultMessage: "Search..."
                                                                                            })}
                                                                                            value={searchValue[formField.fieldCode]}
                                                                                            onChange={e => setSearchValue(preData=>({
                                                                                                ...preData,
                                                                                                [formField.fieldCode]: e.target.value
                                                                                            }))}
                                                                                            onKeyDown={e => e.stopPropagation()}
                                                                                            suffix={<SearchOutlined />}
                                                                                        />
                                                                                    </div>
                                                                                    <Divider style={{ margin: '8px 0' }} />
                                                                                    {menu}
                                                                                </div>)}
                                                                                allowClear={true}
                                                                            />
                                                                        </Form.Item> : 
                                                                        formField.fieldType === 'file' ? <Upload
                                                                            onRemove={handleRemoveFile}
                                                                            beforeUpload={handleBeforeUpload}
                                                                            customRequest={handleFormatFile}
                                                                            onChange={handleOnChangeFile}
                                                                            fileList={fileList}
                                                                            maxCount={1}
                                                                            accept=".png,.gif,.jpg,.jpeg,.pdf"
                                                                        >
                                                                            <div className={classes.uploadButton}>
                                                                                <FormattedMessage id={'form.uploadBtn'} defaultMessage={'UPLOAD'} />
                                                                                {formField.isRequired ? '*' : ''}
                                                                            </div>
                                                                            <MessageSection alertMessage={uploadAlertMessage} setAlertMessage={setUploadAlertMessage} />
                                                                            <div className={classes.uploadTips}>
                                                                                <FormattedMessage id={'form.uploadSizeTips'} defaultMessage={'Files must be less than 5MB.'} />
                                                                                <br />
                                                                                <FormattedMessage id={'form.uploadTypeTips'} defaultMessage={'Allowed file types: png gif jpg jpeg pdf.'} />
                                                                            </div>
                                                                        </Upload> :
                                                                        formField.fieldType === 'date' ? <Form.Item 
                                                                            name={formField.fieldCode}
                                                                            rules={!formField.isRequired ? [] : [{ required: true, message: formatMessage({
                                                                                id: "form.isRequired", 
                                                                                defaultMessage: "{name} is required!"
                                                                            }, {
                                                                                name: formField.fieldName
                                                                            }) }]}
                                                                        >
                                                                            <DatePicker
                                                                                placeholder={`${formField.fieldName} ${formField.isRequired ? '*' : ''}`}
                                                                                onChange={handleChangeDatePicker}
                                                                                maxDate={formField.fieldCode === 'invoice_date' ? dayjs(todayDate, 'YYYY-MM-DD') : undefined}
                                                                            />
                                                                        </Form.Item> :
                                                                        formField.fieldType === 'checkbox' ? <Form.Item 
                                                                            name={formField.fieldCode}
                                                                            rules={!formField.isRequired ? [] : [{
                                                                                validator: (_, value) =>
                                                                                value ? Promise.resolve() : Promise.reject(new Error(formatMessage({
                                                                                        id: "form.isRequiredAccept", 
                                                                                        defaultMessage: "You must accept this to proceed."
                                                                                    }, {
                                                                                        name: formField.fieldCode
                                                                                    }))),
                                                                                }
                                                                            ]}
                                                                            valuePropName="checked"
                                                                        >
                                                                            <Checkbox>
                                                                                {
                                                                                    formField.link ? <a href={formField.link} target="_blank" rel="noreferrer">
                                                                                        {`${formField.fieldName} ${formField.isRequired ? '*' : ''}`}
                                                                                    </a> : `${formField.fieldName} ${formField.isRequired ? '*' : ''}`
                                                                                }
                                                                            </Checkbox>
                                                                        </Form.Item> : null
                                                                    }
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            })
                                        }
                                        {
                                            w_ind === warrantyGroup?.length-1 ? <div className={classes.actions}>
                                                <div style={{display: 'flex'}}>
                                                    <Button className={classes.submitButton} htmlType="submit" disabled={btnDisable}>
                                                        <FormattedMessage id="form.sendButton" defaultMessage={"SEND"} />
                                                    </Button>
                                                </div>
                                                <MessageSection alertMessage={alertMessage} setAlertMessage={setAlertMessage}/>
                                            </div> : null
                                        }
                                    </Col>
                                })
                            }
                        </Row>
                    </Form>
                </div>
            }
        </Spin>
    }, [alertMessage, allSelectOptions, allSelectValues, bigclientWidth, btnDisable, contextHolder, errorMessage, fileList, form, 
        formatMessage, handleBeforeUpload, handleChangeDatePicker, handleChangeEmail, handleChangeSelect, handleFormatFile, 
        handleGetRules, handleOnChangeFile, handleRemoveFile, handleSubmitForm, loading, otpNode, searchValue, setAlertMessage, 
        setSearchValue, setUploadAlertMessage, todayDate, uploadAlertMessage, validateOtpLoading, warrantyGroup])

    function isIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true; // 跨域访问报错时，也说明在 iframe 中
        }
    }

    return <>
        <Helmet >
            <title>Warranty Form</title>
            <meta name="description" content="Warranty Form" />
            <link rel="icon" href="https://www.gaxas.ai/api/media/file/favicon-1.svg"/>
        </Helmet>
        <MainComponent children={FormContent} isIframe={isIframe()}/>
        
    </>
}

export default WarrantyForm